<template>
  <article role="article" class="data pw-location">
    <div
      class="field field--name-field-location-name field--type-string field--label-hidden field__item"
    >
      {{ pos.field_location_name }}
    </div>

    <div
      v-if="pos.field_address_city"
      class="field field--name-field-location-address field--type-address field--label-hidden field__item"
    >
      <address class="address" translate="no">
        {{ pos.field_address_street }} {{ pos.field_address_housenumber }}
        <br />
        {{ pos.field_address_postalcode }} {{ pos.field_address_city }}
      </address>
    </div>

    <div
      class="field field--name-field-pw-action-ref field--type-entity-reference field--label-hidden field__items"
    >
      <div class="field__item">
        <article role="article" class="data pw-action" v-if="pos.team">
          <div
            class="field field--name-name field--type-string field--label-inline"
          >
            <div class="field__label">Door</div>
            <div class="field__item">{{ pos?.team?.label }}</div>
          </div>

          <div
            class="field field--name-field-pw-action-day-ref field--type-entity-reference field--label-hidden field__items"
            v-if="pos.field_timeslots"
          >
            <template v-for="timeslot in pos.field_timeslots" :key="timeslot">
              <div class="field__item">
                <div class="pw_action_day__date">
                  {{ formatDate(timeslot.date) }}
                </div>
                <div class="pw_action_day__times">
                  <div class="pw_action_day__time">
                    {{ timeslot.start_time }} - {{ timeslot.end_time }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </article>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PwPos',
  props: {
    pos: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Drupal: this.$drupal,
    }
  },
  methods: {
    formatDate(value) {
      if (value) {
        const date = new Date(String(value));
        return date.toLocaleDateString("nl-BE", {
          day: "2-digit",
          month: "short"
        }).replace(".", ""); // Remove the period that Belgian locale adds after abbreviated months
      }
    }
  },
};
</script>
